module.exports = __webpack_public_path__ + "media/images/pic/courses/intermediate-level-bdcb76453c73af98d216bd6f2e1cd426.png";